import React from "react";
import CustomCalendar from "@/components/CustomCalendar";
import { Label } from "@/components/ui/label";

export default function MultiDateSelector({ selectedDates, onDatesChange, minDate = new Date(), className = "" }) {
    const handleDateSelect = (date) => {
        if (!date) return;
        
        // Use timezone-neutral date conversion to avoid date shifting
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const dateString = `${year}-${month}-${day}`;
        
        const isSelected = selectedDates.includes(dateString);
        
        if (isSelected) {
            // Remove date if already selected
            const newDates = selectedDates.filter(d => d !== dateString);
            onDatesChange(newDates);
        } else {
            // Add date if not selected
            const newDates = [...selectedDates, dateString].sort();
            onDatesChange(newDates);
        }
    };

    const formatSelectedDates = () => {
        if (selectedDates.length === 0) return "No dates selected";
        if (selectedDates.length === 1) return `1 date selected`;
        return `${selectedDates.length} dates selected`;
    };

    const getStartAndEndDates = () => {
        if (selectedDates.length === 0) return { start: null, end: null };
        const sortedDates = [...selectedDates].sort();
        return {
            start: sortedDates[0],
            end: sortedDates[sortedDates.length - 1]
        };
    };

    const { start: startDate, end: endDate } = getStartAndEndDates();

    return (
        <div className={className}>
            <Label>Select Job Days</Label>
            <div className="mt-2">
                <CustomCalendar
                    selectedDates={selectedDates}
                    onDateSelect={handleDateSelect}
                    minDate={minDate}
                />
                
                <div className="mt-4 p-4 bg-gray-50 rounded-lg space-y-2">
                    <p className="text-sm font-medium">{formatSelectedDates()}</p>
                    {startDate && endDate && (
                        <div className="text-sm text-gray-600">
                            <p>Start Date: {new Date(startDate).toLocaleDateString()}</p>
                            <p>End Date: {new Date(endDate).toLocaleDateString()}</p>
                        </div>
                    )}
                    {selectedDates.length > 0 && (
                        <div className="mt-2">
                            <p className="text-xs text-gray-500 mb-1">Selected dates:</p>
                            <div className="flex flex-wrap gap-1">
                                {selectedDates.map(date => (
                                    <span
                                        key={date}
                                        className="inline-block px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded"
                                    >
                                        {new Date(date).toLocaleDateString()}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
